import { createContext, useContext } from 'react';

/**
 * Shared by the sub-components of a manage listing card
 * @property {Object} listing - ensured own listing
 * @property {Object} actions - see useListingCardActions
 * @property {Function} openModal - opens one of the MODAL_* modals
 */
export const ManageListingCardContext = createContext(null);

export const useManageListingCardContext = () => {
    const context = useContext(ManageListingCardContext);
    if (!context) {
        throw new Error('The context must be used inside <ManageListingCardContext> Provider.');
    }
    return context;
};
